export const UPDATE_CATEGORIES = 'UPDATE_CATEGORIES'
export const UPDATE_LATEST_POSTS = 'UPDATE_LATEST_POSTS'
export const UPDATE_CATE_POSTS = 'UPDATE_CATE_POSTS'
export const UPDATE_CURRENT_CATE = 'UPDATE_CURRENT_CATE'
export const UPDATE_TAG_POSTS = 'UPDATE_TAG_POSTS'
export const UPDATE_EDITOR_POSTS = 'UPDATE_EDITOR_POSTS'
export const UPDATE_CURRENT_EDITOR = 'UPDATE_CURRENT_EDITOR'
export const UPDATE_SEARCH_ARTICLES = 'UPDATE_SEARCH_ARTICLES'
export const UPDATE_SEARCH_GALLERIES = 'UPDATE_SEARCH_GALLERIES'
export const UPDATE_REGION_COUNTRIES = 'UPDATE_REGION_COUNTRIES'
export const UPDATE_BRANDS = 'UPDATE_BRANDS'
export const UPDATE_TOURNAMENTS = 'UPDATE_TOURNAMENTS'
export const UPDATE_UPCOMING_TOURNAMENTS = 'UPDATE_UPCOMING_TOURNAMENTS'
export const UPDATE_EVENTS = 'UPDATE_EVENTS'
export const UPDATE_DATE_PERIOD = 'UPDATE_DATE_PERIOD'
export const UPDATE_FEEDS = 'UPDATE_FEEDS'
export const UPDATE_SERIES = 'UPDATE_SERIES'
export const UPDATE_ALBUMS = 'UPDATE_ALBUMS'
export const UPDATE_ALBUM_IMAGES = 'UPDATE_ALBUM_IMAGES'

export const UPDATE_DISPLAY_CATE_DATA = 'UPDATE_DISPLAY_CATE_DATA'
export const UPDATE_DISPLAY_DATA = 'UPDATE_DISPLAY_DATA'
export const UPDATE_DISPLAY_PAGE = 'UPDATE_DISPLAY_PAGE'
export const PUSH_LIST_OF_CALLED_API = 'PUSH_LIST_OF_CALLED_API'
export const CHANGE_SIZE_TOAST_BANNER = 'CHANGE_SIZE_TOAST_BANNER'
export const CHANGE_OPEN_SHARE_DIALOG = 'CHANGE_OPEN_SHARE_DIALOG'
export const CHANGE_OPEN_FOOTER1_DIALOG = 'CHANGE_OPEN_FOOTER1_DIALOG'
export const CHANGE_OPEN_FOOTER2_DIALOG = 'CHANGE_OPEN_FOOTER2_DIALOG'
export const CHANGE_OPEN_FOOTER3_DIALOG = 'CHANGE_OPEN_FOOTER3_DIALOG'
export const CHANGE_OPEN_FAQ_DIALOG = 'CHANGE_OPEN_FAQ_DIALOG'
export const CHANGE_OPEN_TEAM_DIALOG = 'CHANGE_OPEN_TEAM_DIALOG'
export const UPDATE_OPEN_DROPDOWN = 'UPDATE_OPEN_DROPDOWN'
export const UPDATE_CURRENT_CONTENTS_DATA = 'UPDATE_CURRENT_CONTENTS_DATA'
